import React from 'react'

import { ComponentVariant } from '../../../utils/defaultTypes'

import M006M from './M006-M'
import M006L from './M006-L'

const M006 = (props) => {
  const { settings } = props

  switch (settings.variant) {
    case 'medium':
      return <M006M {...props} />

    case 'large':
      return <M006L {...props} />

    default:
      return null
  }
}

M006.defaultProps = {
  settings: {
    variant: ComponentVariant.MEDIUM,
  },
}

export default M006
